import { Component, ViewContainerRef } from '@angular/core';
import { BlogCategory } from '../../models/blog/blog-category-model';
import { BlogCategoryService } from '../../services/blog/blog-category.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Blog } from '../../models/blog/blog-model';
import { RolePermissionService } from '../../services/role/role-permission.service';


@Component({
    selector: 'app-create-blog-category',
    templateUrl: './create-blog-category.component.html',
    styleUrls: ['./create-blog-category.component.css']
})
/** create-blog-category component*/
export class CreateBlogCategoryComponent {
    /** create-blog-category ctor */
  public blogCategory = new BlogCategory();
  validate: boolean;
  constructor(private readonly blogCategoryService: BlogCategoryService, public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("blogcategory").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.blogCategory.isActive = true;
            this.validate = true;
            this.blogCategory.blogCategoryIndex = null;

          }
          else {
            this.router.navigate(["/blogcategory-list"]);
          }
        }
        else {
          this.router.navigate(["/blogcategory-list"]);
        }
      }
    )
  }
  isActiveCheckbox(e) {
    this.blogCategory.isActive = e.target.checked;
  }
  onSubmit() {
    this.validate = false;
    this.blogCategoryService.addBlogCategory(this.blogCategory).subscribe(result => {
      if (result) {
        this.toastr.success('Blog Category has been Saved. ', 'Success');
        setTimeout(() => {
          this.router.navigate(["/blogcategory-list"]);
        }, 2000);
      }
      else {
        this.toastr.error('Error occurred. Oop!', 'Success');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/blog-components/create-blog-category/create-blog-category.component.ts